// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  apiSSO: 'https://api.sso.dev.movisat.com',
  webSSO: 'https://dev.my.movisat.com',
  // webSSO: 'http://localhost:4200',
  // apiSSO: 'https://localhost:44343',
  // apiSSO: 'https://api.sso.preproduccion.movisat.com',
  // webSSO: 'https://preproduccion.my.movisat.com',

  jqLicense: '75CE8878-FCD1-4EC7-9249-BA0F153A5DE8', // Licencia para los componentes JqWidgets

  tema: 'arctic', // Tema para los componentes JQWidgets

  grantTypeSSO: 'password',
  clientIdSSO: "U32FFNX5AG39DECT",
  clientSecretSSO: "M65Y4L658QNFKQ2PSQWX5S5XEC7WDNBVSV2UH2GRGNZGEUATQX",
  userNameSSO: "movisat@np",
  passwordSSO: "M0v15AT@np2021",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
